module.exports = __webpack_public_path__ + "static/media/svice.08880863.jpg";